export const USER_PROFILE_STATUS = [
  { label: 'Chờ bổ sung', value: 0, key: 'WAITING_FOR_COMPLETION', className: 'status-pending' },
  { label: 'Chờ xác nhận', value: 1, key: 'WAITING_FOR_APPROVAL', className: 'status-info' },
  { label: 'Xác nhận', value: 2, key: 'APPROVAL', className: 'status-success' },
  { label: 'Từ chối', value: 3, key: 'REJECTED', className: 'status-error' },
];

export const USER_PROFILE_STATUS_MAP = {
  WAITING_FOR_COMPLETION: 0,
  WAITING_FOR_APPROVAL: 1,
  APPROVAL: 2,
  REJECTED: 3,
};
